import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var StepLabelTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: {
                alignItems: "flex-start",
            },
            labelContainer: {
                '.MuiStepLabel-label': (_a = {
                        fontSize: theme.typography.body1.fontSize
                    },
                    _a[breakpoints.down('sm')] = {
                        fontSize: "0.813rem", //13
                    },
                    _a.fontWeight = "bold",
                    _a.color = theme.palette.text.primary,
                    _a['&:only-of-type'] = {
                        marginTop: 3,
                    },
                    _a),
            },
        },
    });
};
export default StepLabelTheme;
//# sourceMappingURL=theme.js.map